import { Checkbox, FormControlLabel, Stack } from "@mui/material";
import { PaperMaterialInventoriesPermission } from "commons/enum/permission";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { ExportExcelButton } from "share-components/mui-wrap/button/action-button";
import { SearchButton } from "share-components/mui-wrap/button/search-button";
import { PageContentContainer } from "share-components/templates/page/page-content-container";
import { PageFilterContainer } from "share-components/templates/page/page-filter-container";
import { PaperMaterialGroupSelectionConnected } from "../share";
import { ExportExcel } from "./export-excel/export-excel";
import { PaperInventoryTable } from "./paper-inventory-table";

export const PaperInventoryList = observer(() => {
  const {
    paperInventoryManagement: {
      paperInventoryStore: {
        pagination,
        openExportExcel,
        getPapersInventory,
        queryParams: {
          gsm,
          type,
          code,
          brand,
          specificationSize,
          rollNumber,
          showZeroQuantity,
          setProp: setQueryParamProps,
        },
        setProp,
      },
    },
  } = useStores();
  const onSearch = useCallback(async () => {
    pagination.setProp("pageIndex", 0);
    await getPapersInventory();
  }, [getPapersInventory, pagination]);

  const showZeroQuantityHandler = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      setQueryParamProps("showZeroQuantity", checked);
      getPapersInventory();
    },
    [getPapersInventory, setQueryParamProps],
  );
  return (
    <>
      <PageFilterContainer>
        <PaperMaterialGroupSelectionConnected
          codeSelected={code}
          specificationSizeSelected={specificationSize}
          brandSelected={brand}
          rollNumberSelected={rollNumber}
          typeSelected={type}
          gsmSelected={gsm}
          setSelectionProp={setQueryParamProps}
        />

        <SearchButton asyncAction={onSearch}></SearchButton>
      </PageFilterContainer>
      <Stack
        direction={"row"}
        justifyContent={"right"}
        sx={{ marginTop: "10px" }}
        spacing={1}
      >
        <ExportExcelButton
          accessPermission={[
            PaperMaterialInventoriesPermission.ExportExcelByRollNumber,
          ]}
          onClick={() => {
            setProp("openExportExcel", true);
          }}
        ></ExportExcelButton>
        <FormControlLabel
          control={
            <Checkbox
              checked={showZeroQuantity}
              onChange={showZeroQuantityHandler}
            />
          }
          label="Gồm tồn bằng 0"
        />
      </Stack>
      <PageContentContainer sx={{ marginTop: "10px" }}>
        <PaperInventoryTable></PaperInventoryTable>
      </PageContentContainer>

      <>{openExportExcel && <ExportExcel></ExportExcel>}</>
    </>
  );
});
